import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import './CTASection.css';

gsap.registerPlugin(ScrollTrigger);

export default function CTASection() {
  const sectionRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    const ctx = gsap.context(() => {
      gsap.fromTo(titleRef.current,
        { y: 60, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1.2,
          ease: 'power4.out',
          scrollTrigger: {
            trigger: sectionRef.current,
            start: 'top 75%',
            toggleActions: 'play none none reverse',
          },
        }
      );
    }, sectionRef);
    return () => ctx.revert();
  }, []);

  return (
    <section className="cta2-section" id="about" ref={sectionRef}>
      {/* Ambient background glow */}
      <div className="cta2-glow" />

      <div className="cta2-container" ref={titleRef}>
        <span className="cta2-label">Démarrons Ensemble</span>

        <h2 className="cta2-title">
          VOTRE PROJET<br />
          <em>COMMENCE ICI.</em>
        </h2>

        <p className="cta2-desc">
          Un expert vous répond sous 24h.<br />
          Consultation gratuite, sans engagement.
        </p>

        <div className="cta2-actions">
          <a
            href="https://wa.me/212661338406?text=Bonjour%20Luxury%20Wood%20Concept%2C%20je%20voudrais%20démarrer%20un%20projet."
            target="_blank"
            rel="noopener noreferrer"
            className="cta2-btn cta2-btn--primary"
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="white">
              <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347"/>
            </svg>
            Discuter sur WhatsApp
          </a>
          <a href="/contact" className="cta2-btn cta2-btn--ghost">
            Remplir le formulaire →
          </a>
        </div>

        {/* Trust pills */}
        <div className="cta2-trust">
          <span className="cta2-pill">
            <svg className="cta2-pill__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
            </svg>
            Réponse sous 24h
          </span>
          <span className="cta2-pill">
            <svg className="cta2-pill__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
            </svg>
            Devis Gratuit
          </span>
          <span className="cta2-pill">
            <svg className="cta2-pill__icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/><circle cx="12" cy="10" r="3"/>
            </svg>
            Tout le Maroc
          </span>
        </div>
      </div>
    </section>
  );
}
